var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-col",
    { staticClass: "ma-0 pa-0", attrs: { cols: "12", align: "center" } },
    [
      _c(
        "v-row",
        { staticClass: "ma-0 pa-0", attrs: { align: "center" } },
        _vm._l(_vm.loaderCount, function (item) {
          return _c(
            "v-col",
            {
              key: item,
              staticClass: "ma-0 pa-2",
              attrs: { cols: "4", align: "center" },
            },
            [
              _c("v-skeleton-loader", {
                attrs: {
                  boilerplate: false,
                  elevation: "0",
                  dark: "",
                  type: "image",
                  width: _vm.width,
                  height: _vm.height,
                },
              }),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }